import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { http } from "@/lib/api";
import { Loader2, Clock, ArrowLeft, Lock } from "lucide-react";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => {
    http.get(`/blog/${slug}`)
      .then((r) => setP(r.data))
      .catch((err) => setP(err.response?.status === 401 ? "locked" : false));
  }, [slug]);
  if (p === null) return <div className="min-h-[50vh] grid place-items-center"><Loader2 className="animate-spin text-brand-500" /></div>;
  if (p === "locked") return (
    <div className="container-x py-20 max-w-xl mx-auto text-center" data-testid="blog-member-gate">
      <div className="mx-auto grid place-items-center h-14 w-14 rounded-2xl bg-brand-100 text-brand-700 mb-6"><Lock strokeWidth={1.5} /></div>
      <h1 className="font-display text-3xl font-bold text-slate-900 tracking-tight">Un contenu réservé à la communauté Beehive.</h1>
      <p className="mt-4 text-slate-600 leading-relaxed">Les articles et conseils des experts sont accessibles aux membres. Créez gratuitement votre profil pour les consulter.</p>
      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/inscription" data-testid="gate-register" className="btn-primary">Créer mon profil gratuitement</Link>
        <Link to="/connexion" data-testid="gate-login" className="btn-outline">Se connecter</Link>
      </div>
    </div>
  );
  if (p === false) return <div className="container-x py-20 text-center">Article introuvable. <Link to="/blog" className="link-inline">Retour</Link></div>;
  return (
    <article className="container-x py-14 max-w-3xl mx-auto">
      <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-800"><ArrowLeft size={14} /> Retour au blog</Link>
      <div className="eyebrow mt-6">Article Beehive</div>
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mt-3">{p.title}</h1>
      <div className="flex items-center gap-3 text-xs text-slate-500 mt-5">
        <span>{p.author}</span>·<span className="flex items-center gap-1"><Clock size={12} strokeWidth={1.5} />{p.reading_time} min de lecture</span>
      </div>
      <div className="mt-8 rounded-3xl overflow-hidden">
        <img src={p.cover} alt={p.title} className="w-full aspect-[16/9] object-cover" />
      </div>
      <div className="mt-10 text-slate-700 leading-relaxed text-lg whitespace-pre-line">{p.content}</div>
    </article>
  );
}
